import { NODE_ENV } from '@com/config/env'
import { Referrer } from '@pt/enums/referrer'

export default function sendGtag(opt) {
  let referrer = ''
  const url = new URL(window.location.href)
  const href = url.href.split('?')[1]
  if (href) {
    const params = new URLSearchParams(href)
    const utmSource = params.has('campaignid')
    if (utmSource) {
      referrer = Referrer.Delivery
    } else {
      referrer = Referrer.Natural
    }
  } else {
    referrer = Referrer.Natural
  }

  window.gtag &&
    window.gtag('event', `${opt.name}`, {
      /* eslint-disable */
      'node_env': NODE_ENV,
      'page_referrer': referrer
      /* eslint-enable */
    })
  console.log(`${opt.name} success!`)
}
